import $ from 'jquery';
export default function initializeNavigationMobile() {

    //======================================================================================================
    // Menu öffnen beim Klick auf Hamburger
    //======================================================================================================
    let hamburger = document.querySelector(".hamburg");
    hamburger.onclick = function () {
        this.classList.toggle ("checked");
    }
    $(".menu-mobile .navbar-toggler").on('click',function(){
        $("main").toggleClass("open-dropdown-menu-level-0");
        $("footer").toggleClass("open-dropdown-menu-level-0");
        $("header").toggleClass("open-dropdown-menu-level-0");
        $(".menu-mobile .navbar-brand").toggleClass("hide-logo-big");
        $(".logo-mobile").toggleClass("show-logo-small");
        $(".menu-mobile .collapse.navbar-collapse").toggleClass("show");
    });

    $(".consulat-contact-link > a").on('click',function(e){
        //======================================================================================================
        // Wenn das Mobile-Menu geoeffnet ist, soll beim Klick auf Kontakt, sich das Menu schließen
        //======================================================================================================
        if((window.innerWidth <= 992) || (window.innerHeight <= 699)) {
            $("main").toggleClass("open-dropdown-menu-level-0");
            $("footer").toggleClass("open-dropdown-menu-level-0");
            $("header").toggleClass("open-dropdown-menu-level-0");
            $(".menu-mobile .navbar-brand").toggleClass("hide-logo-big");
            $(".logo-mobile").toggleClass("show-logo-small");
            $(".menu-mobile .collapse.navbar-collapse").toggleClass("show");
            $(".hamburg").toggleClass("checked");
        }
        //======================================================================================================
        // Link für das Formular auf Pfleichseiten soll auf Startseite führen
        //======================================================================================================
        /*let urllink = window.location.href;
        if(urllink.includes("impressum")) {
            e.preventDefault();
            let newUrl = document.location.origin + "/#contact-hoffmann";
            window.location.replace(newUrl);
        }
        if(urllink.includes("datenschutz")) {
            e.preventDefault();
            let newUrl = document.location.origin + "/#contact-hoffmann";
            window.location.replace(newUrl);
        }
        if(urllink.includes("online-termin")) {
            e.preventDefault();
            let newUrl = document.location.origin + "/#contact-hoffmann";
            window.location.replace(newUrl);
        }*/
    });

    $(".email-sticky > a").on('click',function(e){

        //======================================================================================================
        // Wenn das Mobile-Menu geoeffnet ist, soll beim Klick auf Kontakt, sich das Menu schließen
        //======================================================================================================
        if((window.innerWidth <= 992) || (window.innerHeight <= 699)){

            if($("main").hasClass( "open-dropdown-menu-level-0" )) {
                $("main").removeClass("open-dropdown-menu-level-0");
            }
            if($("footer").hasClass("open-dropdown-menu-level-0")) {
                $("footer").removeClass("open-dropdown-menu-level-0");
            }
            if($("header").hasClass("open-dropdown-menu-level-0")) {
                $("header").removeClass("open-dropdown-menu-level-0");
            }
            if($(".menu-mobile .navbar-brand").hasClass("hide-logo-big")) {
                $(".menu-mobile .navbar-brand").removeClass("hide-logo-big");
            }
            if($(".logo-mobile").hasClass("show-logo-small")) {
                $(".logo-mobile").removeClass("show-logo-small");
            }
            if($(".menu-mobile .collapse.navbar-collapse").hasClass("show")) {
                $(".menu-mobile .collapse.navbar-collapse").removeClass("show");
            }
            if($(".hamburg").hasClass( "checked" )) {
                $(".hamburg").removeClass("checked");
            }

        }
        //======================================================================================================
        // Link für das Formular auf Pfleichseiten soll auf Startseite führen
        //======================================================================================================
        /*let url = window.location.href;
        if(url.includes("impressum")) {
            e.preventDefault();
            let newUrl = document.location.origin + "/#contact-hoffmann";
            window.location.replace(newUrl);
        }
        if(url.includes("datenschutz")) {
            e.preventDefault();
            let newUrl = document.location.origin + "/#contact-hoffmann";
            window.location.replace(newUrl);
        }
        if(url.includes("online-termin")) {
            e.preventDefault();
            let newUrl = document.location.origin + "/#contact-hoffmann";
            window.location.replace(newUrl);
        }*/


    });

    //======================================================================================================
    // Anzeige Menu Ebene 0 und Ebene 1
    //======================================================================================================
    $(".menu-mobile .level-0.nav-link.dropdown-toggle").on('click',function(){

        $(this).toggleClass("display-only-this");
        if ($(this).hasClass("display-only-this")) {
            $(this).parent().siblings().addClass("not-display-this");
            $(this).parent().parent().siblings().addClass("not-display-this");
            $(this).siblings().addClass("display-level-1");
        }
        else {
            $(this).parent().siblings().removeClass("not-display-this");
            $(this).parent().parent().siblings().removeClass("not-display-this");
            $(this).siblings().removeClass("display-level-1");
        }

    });

    //======================================================================================================
    // Anzeige Menu Ebene 1 und Ebene 2
    //======================================================================================================
    $(".menu-mobile .level-1.nav-link.dropdown-toggle").on('click',function(){
        $(this).toggleClass("display-only-this");
        if ($(this).hasClass("display-only-this")) {
            /*let str = $(this).find(".post-title").text();
            $(this).find(".post-title").text(str.toUpperCase());*/
            $('.dropdown-menu-mobile.depth_0.display-level-1').addClass('level-indent');
            $(this).parent().siblings().addClass("not-display-this");
            $(this).parent().parent().siblings().addClass("not-display-this");
            $(this).siblings().addClass("display-level-2");
            let lastChild = $(this).siblings().children().last();

        }
        else {
            $('.dropdown-menu-mobile.depth_0.display-level-1').removeClass('level-indent');
            $(this).parent().siblings().removeClass("not-display-this");
            $(this).parent().parent().siblings().removeClass("not-display-this");
            $(this).siblings().removeClass("display-level-2");
            /*let str = $(this).find(".post-title").text();
            $(this).find(".post-title").text(str.toLowerCase());*/
        }

    });
}